export enum CommonActionTypes {
  RECEIVE_PERSPECTIVE = "RECEIVE_PERSPECTIVE",
  UPDATE_DOCUMENT = "UPDATE_DOCUMENT",
  UPDATE_IS_LOADING = "UPDATE_IS_LOADING",
}
